import { ReactElement, ReactNode } from 'react';
import styled, { ColorsTypes } from 'styled-components';

import { Flex, ButtonIcon } from 'components';

interface ModalProps {
  children: ReactNode;
  onClose?: () => void;
  bg?: ColorsTypes | 'transparent';
  buttonClose?: any;
  buttonClosePosition?: [number, number];
}

const ModalOpacity = styled((props) => <Flex {...props} />)`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
`;

const ButtonCloseWrapper = styled.i`
  position: absolute;
  margin: 0;
  padding: 0;
  top: 0;
  right: 0;
  z-index: 1002;
`;

const Modal = ({ children, onClose, buttonClose, buttonClosePosition = [2, 2], bg = 'white' }: ModalProps): ReactElement => {
  const handleClose = () => {
    if (onClose) onClose();
  };

  const ButtonClose = () => (
    <ButtonIcon
      type="button"
      icon="close"
      width={30}
      height={30}
      bg="transparent"
      color="primary_400"
      colorHover="primary_200"
      onClick={handleClose}
      position="absolute"
      top={buttonClosePosition[0]}
      right={buttonClosePosition[1]}
      zIndex={1002}
    />
  );

  return (
    <ModalOpacity alignItems="center" justifyContent="center">
      <Flex bg={bg} minWidth={200} minHeight={100} flexGrow={0} position="relative" borderRadius={4} mx={5}>
        {buttonClose ? <ButtonCloseWrapper onClick={handleClose}>{buttonClose}</ButtonCloseWrapper> : <ButtonClose />}

        {children}
      </Flex>
    </ModalOpacity>
  );
};

export default Modal;
